/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Skill_S1Inputs */

const en_mk_tut_skill_s1 = /** @type {(inputs: Mk_Tut_Skill_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Skills**, press new, and write the steps in plain language.`)
};

const id_mk_tut_skill_s1 = /** @type {(inputs: Mk_Tut_Skill_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka menu **Skill**, tekan buat baru, lalu tulis langkah-langkahnya dalam bahasa biasa.`)
};

/**
* | output |
* | --- |
* | "Open **Skills**, press new, and write the steps in plain language." |
*
* @param {Mk_Tut_Skill_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_skill_s1 = /** @type {((inputs?: Mk_Tut_Skill_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Skill_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_skill_s1(inputs)
	return en_mk_tut_skill_s1(inputs)
});